import getInsuranceInsuredsDob1 from 'utils/print/getInsuranceInsuredsDob1';
import getInsuranceInsuredsDob2 from 'utils/print/getInsuranceInsuredsDob2';
import getInsuranceInsuredsDob3 from 'utils/print/getInsuranceInsuredsDob3';

const getInsuranceInsuredsFullDob = ({ value, ...otherProps }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  return `${getInsuranceInsuredsDob1(otherProps)}/${getInsuranceInsuredsDob2(otherProps)}/${getInsuranceInsuredsDob3(otherProps)}`;
};

export default getInsuranceInsuredsFullDob;



// WEBPACK FOOTER //
// ./src/utils/print/getInsuranceInsuredsFullDob.js